export const SET_FIRST_AVAILABLE_TIME_SLOT = 'SET_FIRST_AVAILABLE_TIME_SLOT';
export const SET_FIRST_AVAILABLE_TIME_SLOT_TEAMS_ID =
  'SET_FIRST_AVAILABLE_TIME_SLOT_TEAMS_ID';



// WEBPACK FOOTER //
// ./src/store/reducers/firstAvailableTimeSlot/actionTypes.js